var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-image-block {\n  border-radius: 200px;\n  -webkit-box-shadow: 2px 2px 10px #4e4e4e;\n          box-shadow: 2px 2px 10px #4e4e4e;\n  min-height: 350px;\n  margin: 20px auto;\n  width: 350px;\n}\n\n.home-image {\n  background-image: url(" + escape(require("../../assets/img/abel-trotter-portfolio-picture.jpg")) + ");\n  background-position: 100% 100%;\n  background-size: 120%;\n}\n\n/* responsive styles */\n\n@media screen and (max-width: 500px) {\n  .profile-image-block {\n    border-radius: 0px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main